
import Prepaid from "@/interfaces/Contracts/Prepaid";
import { Vue, Component, Prop } from "vue-property-decorator";
import CardListDetailField from "@/components/Base/CardListDetail/CardListDetailField.vue";

@Component({ components: { CardListDetailField } })
export default class DetailPrepaidHeader extends Vue {
  @Prop({ required: true })
  prepaid!: Prepaid;

  @Prop({ required: false, default: false })
  loading!: boolean;
}
